// TODO Full support of import/export instead of assigning to the window object
import $ from 'jquery';
import Moment from 'moment-timezone';
import toastr from 'toastr';
import { clone, transform, isEqual, isObject } from 'lodash';
import { i18n } from '@/plugins/i18n';
import { getFullscreenElement } from '@/utils/fullscreen';


/** Used as a loading logo */
/* eslint-disable-next-line global-require */
export const shizenLogo = require('@/assets/img/logo-300-normal.png');

/** When switching between same component pages, if this array contains the path
  of the component, IA help and overlay won't hide unexpectedly */
export const keepIAOnRouteChange = ['/schedule'];

/** From http://detectmobilebrowsers.com */
function checkMobile() {
  let isMobile = false;
  const isMobileTest = (navigator.userAgent || navigator.vendor || window.opera);
  /* eslint-disable-next-line */
  if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(isMobileTest) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(isMobileTest.substr(0, 4))) {
    isMobile = true;
  }
  return isMobile;
}
export const isMobile = checkMobile();
window.isMobile = isMobile;

/**
 * Check if a device is an android, iphone, ipad
 * @return {Boolean}
 */
export function isSmartphone() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /windows phone|android|iPad|iPhone|iPod/i.test(userAgent);
}

/**
 * Check if the device is a touch device.
 * From https://stackoverflow.com/a/4819886
 * This isn't from any official JS documentation, which makes it quite unsafe to use for vital features.
 * @return {Boolean}
 */
export function checkTouchDevice() {
  if (
    ('ontouchstart' in window)
    || (navigator.maxTouchPoints > 0)
    || (navigator.msMaxTouchPoints > 0)
  ) {
    return true;
  }
  const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
  /* eslint-disable-next-line func-names */
  const mq = function (query) {
    return window.matchMedia(query).matches;
  };
  /* eslint-disable-next-line no-undef */
  if (('ontouchstart' in window) || (window.DocumentTouch && document instanceof DocumentTouch)) {
    return true;
  }
  // include the 'heartz' as a way to have a non matching MQ to help terminate the join https://git.io/vznFH
  const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
  return mq(query);
}
export const isTouchDevice = checkTouchDevice();
window.isTouchDevice = isTouchDevice;

let mainAlert = null;
/** If body is not visible , change alert's parent */
function setAlertParent() {
  const element = $(mainAlert).detach();
  let parent = getFullscreenElement();
  if (!parent) {
    parent = document.body;
  }
  $(parent).append(element);
}

$(document).ready(() => {
  /* eslint-disable-next-line */
  mainAlert = $.parseHTML('<div id="v-alert" class="v-centerer f-h f-w">\
    <div class="alert-content">\
      <div id="v-alert-msg"></div>\
      <div id="v-alert-fields"></div>\
      <div id="v-alert-btns"></div>\
    </div>\
  </div>')[0];
  $(document.body).append(mainAlert);
});

let calertHiding = false;

/** Hide the alert shown with calert(..) */
export function calertHide() {
  calertHiding = true;
  $('#v-alert').off();
  $('#v-alert .alert-content').off();
  $(mainAlert).animate({ opacity: 0 }, 300, () => {
    $(mainAlert).css('z-index', '-1');
    $('#v-alert-msg').html('');
    $('#v-alert-btns').html('');
    $('#v-alert-fields').html('');
    calertHiding = false;
  });
}
window.calertHide = calertHide;

/** Alert to replace javascript alert()
  @Param message: message of the dialog box
  @Param buttons: array of object like { title: '', action: function(){} }
          Optional values : color (CSS value)
  @Param customClass: custom class of the dialog box
  @Param fields: if set, display fields below the text msg
*/
export function calert(message, buttons, noDismiss, customClass, fields, onHide) {
  if (!mainAlert) {
    setTimeout(() => {
      calert(message, buttons, noDismiss, customClass, fields, onHide);
    }, 50);
    return;
  }
  if (calertHiding) {
    setTimeout(() => {
      calert(message, buttons, noDismiss, customClass, fields, onHide);
    }, 300);
    return;
  }
  setAlertParent();
  const $alertButtons = $('#v-alert-btns');
  $alertButtons.html('');
  $('#v-alert-msg').html(message);

  if (buttons === undefined) {
    buttons = [{ title: i18n.t('message.OK') }];
  }
  for (let i = 0, len = (buttons || []).length; i < len; i++) {
    const btnData = buttons[i];
    let classes = 'generic-border generic-border--text-btn generic-border--blue';
    if (btnData.sClass) {
      if (!(btnData.sClass instanceof Array)) {
        btnData.sClass = [btnData.sClass];
      }
      btnData.sClass.forEach((sClass) => {
        classes += ` generic-border--${sClass}`;
      });
    }
    const btn = $.parseHTML(`<button id="v-alert-btn${i}" class="${classes}">${btnData.title}</button>`)[0];
    $alertButtons.append(btn);
    if (btnData.hint) {
      $alertButtons.append(`<div class="field-hint">${btnData.hint}</div>`);
    }
    btn.disabled = !!btnData.disabled;
    /* eslint-disable-next-line func-names */
    btn.onclick = function () {
      calertHide();
      if (btnData.action && !btnData.disabled) {
        const fieldValues = [];
        if (fields && fields.length) {
          for (let j = 0, jlen = fields.length; j < jlen; j++) {
            fieldValues.push(fields[j].field ? fields[j].field.value : '');
          }
        }
        btnData.action(fieldValues);
      }
    };
  }
  // Text fields
  if (fields && fields.length) {
    for (let i = 0, len = fields.length; i < len; i++) {
      if (fields[i].pasteonly) {
        /* eslint-disable max-len */
        const elts = $.parseHTML(`
          <div class="v-alert-paste-field">
            <div class="v-alert-paste-field__msg">${i18n.t('message.PASTE_HERE')}</div>
            <div class="v-alert-paste-field__shortcut">${i18n.t('message.PASTE_HERE_SHORTCUT')}</div>
            <input class="bordered-field f-w v-alert-paste-field__field" type="text" id="v-alert-field${i}" placeholder="${fields[i].ph}" />
          </div>
        `);
        /* eslint-enable max-len */
        $('#v-alert-fields').append(elts);
      } else {
        /* eslint-disable-next-line max-len */
        const elts = $.parseHTML(`<input class="generic-border generic-border--thin-border generic-border--focus-shadow f-w" type="text" id="v-alert-field${i}" placeholder="${fields[i].ph}" /><br/>`);
        $('#v-alert-fields').append(elts);
        elts[0].value = fields[i].value || '';
        /* eslint-disable-next-line prefer-destructuring */
        fields[i].field = elts[0];
      }
    }
    if (fields.length === 1) {
      $(fields[0].field).on('keypress', (e) => {
        if (e.keyCode === 13 && buttons[0].action && !buttons[0].disabled) {
          calertHide();
          buttons[0].action([fields[0].field.value]);
        }
      });
    }
  }
  $(mainAlert).css('z-index', '10025');
  $(mainAlert).animate({ opacity: 1 }, 300);
  // Dismiss
  if (!noDismiss) {
    $('#v-alert').on('click', () => {
      calertHide();
      if (onHide) {
        onHide();
      }
    });
    $('#v-alert .alert-content').on('click', (e) => {
      e.stopPropagation();
    });
  }
}
window.calert = calert;

let escapeCallbacks = null;

/** Stop listening for esc key press */
export function undetectEscapeKey() {
  escapeCallbacks.pop();
  if (escapeCallbacks.length > 0) {
    setTimeout(() => { escapeCallbacks[escapeCallbacks.length - 1].elligible = true; }, 1);
  }
}
window.undetectEscapeKey = undetectEscapeKey;

/** Listens for esc key press and calls the provided param on key up */
export function detectEscapeKey(callback) {
  if (!escapeCallbacks) {
    escapeCallbacks = [];
    $(document).on('keyup', (e) => {
      if (
        escapeCallbacks.length > 0
        && Number(e.originalEvent.which) === 27
        && escapeCallbacks[escapeCallbacks.length - 1].elligible
      ) {
        escapeCallbacks[escapeCallbacks.length - 1].callback();
        undetectEscapeKey();
      }
    });
  }
  if (escapeCallbacks.length > 0) {
    escapeCallbacks[escapeCallbacks.length - 1].elligible = false;
  }
  escapeCallbacks.push({ callback, elligible: true });
}
window.detectEscapeKey = detectEscapeKey;

/**
 * Transform a tree-like array into a basic array of objects
 * @param  {Array} tree - Array of tree leaves
 * @param  {String} [childrenKey='zones'] - Key of each item's children array
 * @return {Array} Array of objects. Each leaf of the tree being at the root level
 */
export function treeAsArray(tree, childrenKey = 'zones') {
  const output = [];
  if (tree && tree instanceof Array) {
    tree.forEach((item) => {
      output.push(clone(item));
      if (item[childrenKey]) {
        output.push(...treeAsArray(item[childrenKey], childrenKey));
      }
    });
  }
  return output;
}
window.treeAsArray = treeAsArray;

/**
 * Runs a function (callback) for each item of the tree
 * @param  {Array} tree - parent array
 * @param  {String} [childrenKey='zones'] - key of the children array of each item
 * @param  {Function} callback - function to execute for each item
 */
export function treeTraversal(tree, childrenKey = 'zones', callback) {
  tree.forEach((item) => {
    callback(item);

    if (item[childrenKey] instanceof Array) {
      treeTraversal(item[childrenKey], childrenKey, callback);
    }
  });
  return tree;
}

/**
 * Return a formatted string containing the name of tree items
 * @param  {Array} tree - root array
 * @param  {Array} ids - array of ids to select specific items (null for all items)
 * @param  {String} nameKey - key of the item's name
 * @param  {String} childrenKey - key of items' children array
 * @param  {String} [defaultText=''] - string to use when the output is empty
 * @param  {String} [separator=', '] - string to use to join the items names
 * @return {String} The formatted string
 */
export function treeIdsText(tree, ids, nameKey, childrenKey, defaultText = '', separator = ', ') {
  const itemNames = [];
  const numIds = ids ? ids.map(id => Number(id)) : [];
  treeTraversal(tree, childrenKey, (item) => {
    if (!ids || numIds.includes(Number(item.id))) {
      itemNames.push(item[nameKey]);
    }
  });
  const text = itemNames.join(separator);
  return text === '' ? defaultText : text;
}

/** Remove last '<br>' tag from a string */
export function removeTrailingBreak(str) {
  if (str.endsWith('<br>')) {
    return str.substring(0, str.length - 4);
  }
  return str.replace('<div><br></div>', '');
}

/** Remove the parent node of given param */
function removeLink(el) {
  const $el = $(el);
  const $parent = $el.parent().parent();
  $el.parent().remove();
  if (!$parent.hasClass('textarea')) {
    // Need to remove the elt from the related textarea
    const $ta = $parent.parent().find('.textarea').first();
    const e = document.createEvent('HTMLEvents');
    e.forceValue = $parent.html();
    e.initEvent('input', true, true);
    $ta[0].dispatchEvent(e);
  }
}
window.removeLink = removeLink;
// Very old backward compatibility (January 2019)
window.removePersonLink = removeLink;

/** Deep copy a JS obj */
function copyOfObject(obj) {
  const newObj = {};
  /* eslint-disable-next-line no-restricted-syntax */
  for (const key in obj) {
    /* eslint-disable-next-line no-prototype-builtins */
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === 'object' && obj[key] != null) {
        if (obj[key] instanceof Array) {
          /* eslint-disable-next-line no-use-before-define */
          newObj[key] = copyOfObjectsArray(obj[key]);
        } else if (obj[key]._isAMomentObject) {
          newObj[key] = Moment(obj[key]);
        } else {
          newObj[key] = copyOfObject(obj[key]);
        }
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  return newObj;
}
window.copyOfObject = copyOfObject;

/** Deep copy an array of objects */
function copyOfObjectsArray(array) {
  const newA = [];
  let val;
  for (let i = 0, len = array.length; i < len; i++) {
    val = array[i];
    if (typeof val === 'object' && val != null) {
      if (val instanceof Array) {
        newA.push(copyOfObjectsArray(val));
      } else {
        newA.push(copyOfObject(val));
      }
    } else {
      newA.push(val);
    }
  }
  return newA;
}
window.copyOfObjectsArray = copyOfObjectsArray;

/** Properties of the slider component */
export const sliderProperties = {
  contained: true,
  min: 0,
  max: 3,
  interval: 0.1,
  height: 3,
  dotSize: isTouchDevice ? 20 : 15,
  tooltipStyle: {
    'background-color': 'transparent',
    borderColor: 'transparent',
    color: '#2A5A91',
    'margin-bottom': '-5px',
  },
  processStyle: { 'background-color': '#2A5A91' },
  dotStyle: { 'background-color': '#2A5A91' },
  tooltip: 'always',
};
window.sliderProperties = sliderProperties;

/** Same as above but without the value tooltip */
export const noTooltipSliderProperties = copyOfObject(sliderProperties);
noTooltipSliderProperties.tooltipStyle = { display: 'none' };
window.noTooltipSliderProperties = noTooltipSliderProperties;

function fileTypeFromBase64(base64) {
  return base64.split('/')[1].split(';')[0];
}

/** Reduce the size of a single image base64 string and return it in a callback */
function reduceImageSize(base64, callback, maxSize) {
  maxSize = typeof maxSize === 'undefined' ? 1500 : Number(maxSize);
  const img = new Image();

  let idealWidth;
  let idealHeight;
  /* eslint-disable-next-line */
  img.onload = function () {
    idealWidth = img.width;
    idealHeight = img.height;
    if (img.width >= img.height && img.width > maxSize) {
      idealWidth = maxSize;
      idealHeight = maxSize * img.height / img.width;
    } else if (img.width <= img.height && img.height > maxSize) {
      idealHeight = maxSize;
      idealWidth = maxSize * img.width / img.height;
    }
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = idealWidth;
    canvas.height = idealHeight;
    ctx.drawImage(img, 0, 0, idealWidth, idealHeight);
    const type = fileTypeFromBase64(base64);
    if (type === 'jpg' || type === 'jpeg') {
      callback(canvas.toDataURL('image/jpeg', 0.78));
    } else {
      callback(canvas.toDataURL());
    }
  };
  img.src = base64;
}
window.reduceImageSize = reduceImageSize;

/** Array of images formatted as follow : {data: imageData, type: imageTypeString} */
export function reduceMultipleImages(pictures, callback, maxSize = 1500) {
  const array = [];
  if (pictures.length === 0) {
    callback(array);
    return;
  }
  let imagesToUpdate = 0;
  let imagesUpdated = 0;
  for (let i = 0, len = pictures.length; i < len; i++) {
    if (typeof pictures[i].data === 'undefined') {
      array.push({ id: pictures[i].id });
      continue;
    }
    const finalI = i;
    imagesToUpdate++;
    array.push({ id: pictures[i].id, pictureUrl: pictures[i].pictureUrl, data: '' });
    /* eslint-disable-next-line no-loop-func */
    reduceImageSize(pictures[i].data, (data) => {
      array[finalI].data = data;
      imagesUpdated++;
      if (imagesUpdated === imagesToUpdate) {
        callback(array);
      }
    }, maxSize);
  }
  // No data in array
  if (imagesToUpdate === 0) {
    callback(array);
  }
}
window.reduceMultipleImages = reduceMultipleImages;

/** Converts '<' '>' and '&' to HTML equivalent */
export function safeString(str) {
  return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
window.safeString = safeString;

/** Return given string with a first letter capitalized */
export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
/** Parse contenteditable div content into keywords array */
export function parseKeywords(str) {
  const $str = $(`<div>${str}</div>`);
  const words = [];
  $str.children('span').each((index, node) => {
    words.push($(node).text());
  });
  return words;
}
/** Parse problem fields content to remove HTML tags */
export function removeHTMLSpans(str) {
  const $str = $(`<div>${str}</div>`);
  return $str.text();
}
/** Put the cursor at the end of a contenteditable div */
export function setCursorAtEnd(ta) {
  const range = document.createRange();
  range.selectNodeContents(ta);
  range.collapse(false);
  const sel = window.getSelection();
  sel.removeAllRanges();
  sel.addRange(range);
}

/** Utility to get the caret position in a contenteditable div */
export function getCaretInfo(element) {
  let caretOffset = 0;
  let words = [];
  if (window.getSelection().rangeCount > 0) {
    const range = window.getSelection().getRangeAt(0);
    const preCaretRange = range.cloneRange();
    preCaretRange.selectNode(element);
    preCaretRange.setEnd(range.endContainer, range.endOffset);
    words = preCaretRange.toString().split(/\s+/);
    caretOffset = preCaretRange.toString().length;
  }
  return { offset: caretOffset, words };
}
/** Utility to get the character preceding the caret */
export function getCharBeforeCaret(element) {
  if (window.getSelection().rangeCount > 0) {
    const range = window.getSelection().getRangeAt(0).cloneRange();
    range.collapse(true);
    range.setStart(element, 0);
    return range.toString().slice(-1);
  }
  return '';
}

/**
 * Create a string representing an HTML removable chip element
 * @param  {String} word - Content of the chip
 * @param  {Number} dataId - Value to set as the data-id attribute
 * @param  {String} dataType - Value to set as the data-type attribute
 * @return {String} stringified HTML element
 */
export function removableWord(word, dataId = 0, dataType = 0) {
  // No line breaks around ${word} to prevent having to remove white spaces later
  return `\
    <span \
      contenteditable="false" \
      unselectable="on" \
      class="pr-field-link" \
      data-id="${dataId}" \
      data-type="${dataType}" \
      onclick="" \
    >${word}<img src="/images/close-white.png" onclick="removeLink(this)"/></span>&nbsp;`;
}

/**
 * Replace the oldText at current caret position with the newText enclosed in a span tag
 * See removableWord for the span tag details
 *
 * @param {HTMLElement} textarea - the HTML element that contains the text
 * @param {String} oldText - The text that should be removed
 * @param {String} newText - Text to add and that will be enclosed in the span
 */
export function replaceRemovableWord(textarea, oldText, newtext, dataId = 0, dataType = 0) {
  newtext = newtext || oldText;
  // Delete old text
  let range = window.getSelection().getRangeAt(0);
  const toRemoveRange = range.cloneRange();
  toRemoveRange.selectNode(textarea);
  toRemoveRange.setEnd(range.endContainer, range.endOffset);
  const offsetStart = range.endOffset - oldText.length - 1;
  toRemoveRange.setStart(range.endContainer, offsetStart < 0 ? 0 : offsetStart);
  toRemoveRange.deleteContents();
  // Place new text
  const html = removableWord(newtext, dataId, dataType);
  const sel = window.getSelection();
  range = sel.getRangeAt(0);
  range.deleteContents();

  const el = document.createElement('div');
  el.innerHTML = html;
  const frag = document.createDocumentFragment();
  let node;
  let lastNode;
  /* eslint-disable-next-line no-cond-assign */
  while ((node = el.firstChild)) {
    lastNode = frag.appendChild(node);
  }
  range.insertNode(frag);

  // Preserve the selection
  if (lastNode) {
    range = range.cloneRange();
    range.setStartAfter(lastNode);
    range.collapse(true);
    sel.removeAllRanges();
    sel.addRange(range);
  }
}

/* eslint-disable-next-line */
String.prototype.getLastWord = function () {
  const words = this.split(/\s+/);
  return words[words.length - 1];
};

/**
 * Remove unwanted script and divs from a user input
 * @return {String} Sanitized HTML string
 */
export function safeAutocompleteString(htmlString) {
  if (htmlString === null || htmlString === undefined) {
    return '';
  }
  // Sanitized copy of the above
  const sanitized = document.createElement('div');
  // NOTE: Not using a div created on the current to prevent injection like :
  // <img src="" onerror="alert('Coucou')">
  const htmlDoc = new DOMParser().parseFromString(htmlString, 'text/html');
  if (htmlDoc && htmlDoc.body) {
    htmlDoc.body.childNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        // Text
        sanitized.appendChild(document.createTextNode(node.textContent));
      } else if (
        node.tagName !== undefined
        && node.tagName.toLowerCase() === 'span'
        && node.className === 'pr-field-link'
      ) {
        // Field from autocomplete
        const tmpDiv = document.createElement('div');
        const { textContent, dataset } = node;
        tmpDiv.innerHTML = removableWord(textContent, dataset.id || 0, dataset.type || 0);
        sanitized.appendChild(tmpDiv.children[0]);
      } else {
        // Any other HTML tag => display as plain text
        sanitized.appendChild(document.createTextNode((node.outerHTML)));
      }
    });
  }
  return sanitized.innerHTML;
}

/** Convert value whose keys are in fields to number */
export function convertFieldsToNumber(obj, fields) {
  /* eslint-disable-next-line */
  for (const key in obj) {
    if (fields.indexOf(key) > -1) {
      obj[key] = Number(obj[key]);
    }
  }
  return obj;
}
/** Format number of seconds into an array: [hoursString, minsString, secondsString, daysString] */
export function secondsToArray(data) {
  let secs = 0;
  let mins = 0;
  let hs = 0;
  let js = 0;
  let negative = false;
  if (data < 0) {
    negative = true;
    data = -data;
  }
  secs = data === undefined ? 0 : data;
  if (data > 59) {
    secs = data % 60;
    mins = (data - secs) / 60;
    data = mins;
    if (mins > 59) {
      mins %= 60;
      hs = (data - mins) / 60;
      data = hs;
      if (hs > 23) {
        hs %= 24;
        js = (data - hs) / 24;
      }
    }
  }
  return [(negative ? '-' : '') + hs, (mins > 9 ? '' : '0') + mins, (secs > 9 ? '' : '0') + secs, `${js}`];
}
window.secondsToArray = secondsToArray;

/** Turn an array of ints into array of booleans */
export function parseWorkingDays(days) {
  if (!days || days === '[]') {
    return [true, true, true, true, true, true, true];
  }
  days = days instanceof Array ? days : JSON.parse(days);
  // Check if argument is already an array of parsed working days
  if (!days.some(day => day !== true && day !== false) && days.length === 7) {
    return days;
  }
  const wd = [false, false, false, false, false, false, false];
  for (let j = 0, jLen = days.length; j < jLen; j++) {
    wd[Number(days[j])] = true;
  }
  return wd;
}
window.parseWorkingDays = parseWorkingDays;

/**
 * Check if a date is a working day
 * @param  {Moment}  mDate - Moment instance
 * @param  {Array}  workingDays - Array outputted from parseWorkingDays
 * @return {Boolean} - Whether the mDate is a working day or not
 */
export function isWorkingDay(mDate, workingDays) {
  return workingDays[mDate.isoWeekday() - 1];
}

/**
 * Return the startDate of a 7-working-days range
 * @param daysDiff
 * @param workingDays - 7-boolean values array (see parseWorkingDays)
 * @param endDate - endDate of the range (default: today)
 */
export function getWorkingDaysStartDate(daysDiff, workingDays, endDate) {
  const end = Moment(endDate) || Moment();
  let diff = 0;
  daysDiff = Number(daysDiff);
  workingDays = workingDays || [true, true, true, true, true, false, false];
  if (daysDiff < 0 || daysDiff > 1000 || !workingDays || workingDays.indexOf(true) === -1) {
    return end;
  }
  const startDate = Moment(end);
  while (diff < daysDiff) {
    startDate.subtract(1, 'days');
    if (workingDays[startDate.isoWeekday() - 1]) {
      diff++;
    }
  }
  return startDate;
}

/** Returns the last working day from today as a moment.js instance */
export function getLastWorkingDay(workingDays) {
  const date = Moment();
  const maxDate = Moment().subtract(7, 'days');
  workingDays = workingDays || [true, true, true, true, true, true, true];
  do {
    if (workingDays[date.isoWeekday() - 1]) {
      return date;
    }
  } while (date.subtract(1, 'days').isAfter(maxDate));
  return date;
}
window.getLastWorkingDay = getLastWorkingDay;

/* Return an array of charCode corresponding to the characters given in str */
export function stringToCharCodes(str) {
  const charCodes = [];
  for (let i = 0, len = str.length; i < len; ++i) {
    charCodes.push(str.charCodeAt(i));
  }
  return charCodes;
}
window.stringToCharCodes = stringToCharCodes;

/** Resize a element height to auto */
export function textareaAutoSize(evt, padding = 0) {
  const elt = evt.target;
  const style = window.getComputedStyle(elt, null);
  const eltBorderBotWidth = parseFloat(style.getPropertyValue('border-bottom-width'));
  padding += (eltBorderBotWidth || 0) + (eltBorderBotWidth || 0);
  if (elt) {
    elt.style.height = 'auto';
    elt.style.height = `${elt.scrollHeight + padding}px`;
    // Inner size may have changed due to the scroll bar within the textarea
    elt.style.height = `${elt.scrollHeight + padding}px`;
  }
}
window.textareaAutoSize = textareaAutoSize;

/** Generate a random integer between 0 and max */
export function getRandomInt(max, min = 0) {
  return Math.floor(Math.random() * (max - min)) + min;
}
window.getRandomInt = getRandomInt;

/** Generate a random float between 0 and max */
function getRandomFloat(max) {
  return Math.random() * max;
}
window.getRandomFloat = getRandomFloat;


let preventNextPaste = false;
export function preventPastingStyles(scopeSelector = document) {
  setTimeout(() => {
    const $elmts = $(scopeSelector).find('[contenteditable]:not(.ProseMirror)');
    $elmts.off('paste');
    $elmts.on('paste', (e) => {
      if (!preventNextPaste) {
        e.preventDefault();
        const text = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('text') || '';
        const $result = $(`<div>${text}</div>`);
        // Pasting from word requires a second parsing
        const $result2 = $(`<div>${$result.text()}</div>`);
        if (document.queryCommandSupported('insertText')) {
          document.execCommand('insertText', false, $result2.text());
        } else {
          preventNextPaste = true;
          document.execCommand('paste', false, $result2.text());
        }
      } else {
        preventNextPaste = false;
      }
    });
  }, 50);
}

/** Resize given element to auto height */
export function autoResize($el, noAnimation = false) {
  const autoHeight = $el.css('height', 'auto').height();
  if (noAnimation) {
    $el.css('height', `${autoHeight}px`);
  } else {
    $el.animate({ height: autoHeight }, 150);
  }
}

/** Resize given element to auto */
export function delayResize($el, noAnimation = false) {
  setTimeout(() => {
    autoResize($el, noAnimation);
  }, 50);
}

/**
 * Detect if the color overrun the 'dark' threshold
 * @param  {String}  [bgColor='#000000'] - Colorin hexadecimal format
 * @return {Boolean} - true if the color is dark
 */
export function isColorDark(bgColor = '#000000') {
  if (bgColor === 'transparent') {
    return false;
  }
  const nThreshold = 105;
  const r = parseInt(bgColor.substring(1, 3), 16);
  const g = parseInt(bgColor.substring(3, 5), 16);
  const b = parseInt(bgColor.substring(5, 7), 16);
  const bgDelta = (r * 0.299) + (g * 0.587) + (b * 0.114);
  return (255 - bgDelta) > nThreshold;
}

/** Determine whether a FG color should be white or black according to BG color */
export function getTextFgColor(bgColor, darkColor = '#000000') {
  return isColorDark(bgColor) ? '#ffffff' : darkColor;
}

/** Generate a random color */
export function getRandomColor(dark = true) {
  let letters = '0123456789ABCDEF';
  if (dark) {
    letters = letters.substring(0, 13);
  } else {
    letters = letters.substring(3, 16);
  }
  const lettersLength = letters.length;
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * lettersLength)];
  }
  return color;
}

/** Generate a random color */
export function getRandomRGB(dark = true) {
  let min = 0;
  let max = 255;
  if (dark) {
    max = 200;
  } else {
    min = 55;
  }
  return { r: getRandomInt(max, min), g: getRandomInt(max, min), b: getRandomInt(max, min) };
}

/**
 * Recursively search n tree-like array
 * @param  {Array} items - array of items
 * @param  {Number} id - ID of the item to find
 * @param  {String} [childrenKey='zones'] - key of the children array
 * @param  {Boolean} [preventSearchingFirstLevel=false] - If true, if items of 'items' have the given id,
 *                                                        they won't be returned as a match
 * @return {Object} - The found item (or null)
 */
export function nestedFindItemWithId(items, id, childrenKey = 'zones', preventSearchingFirstLevel = false) {
  for (let i = 0, len = items.length, item; i < len; i++) {
    item = items[i];
    if (!preventSearchingFirstLevel && Number(item.id) === Number(id)) {
      return item;
    } if (item[childrenKey]) {
      const subitem = nestedFindItemWithId(item[childrenKey], id, childrenKey);
      if (subitem) {
        return subitem;
      }
    }
  }
  return null;
}

/**
 * Flatten a x-dimensional array of objects
 * @param  {Array} array - parent array
 * @param  {String} [childrenKey='zones'] - key of the child array property
 * @param  {String} [uniqueKey=null] - key of a property that must be unique in the array
 * @return {Array} - flattened array
 */
export function nestedFlatten(array, childrenKey, uniqueKey = null, alreadyPushed = []) {
  if (array === undefined) {
    return [];
  }
  return array.reduce((acc, el) => {
    if (uniqueKey === null || !alreadyPushed.includes(el[uniqueKey])) {
      if (uniqueKey !== null) {
        alreadyPushed.push(el[uniqueKey]);
      }
      acc.push(el, ...nestedFlatten(el[childrenKey], childrenKey, uniqueKey, alreadyPushed));
    }
    return acc;
  }, []);
}

/**
 * Loop through tree-item children to find a specific item
 * @param  {Array} children - Array of vue components
 * @param  {Object} item - Item wrapped in the component to find
 * @return {VueComponent} - the component that holds the item
 */
export function findTreeItemComponent(children, item) {
  for (let i = 0, len = children.length; i < len; i++) {
    const comp = children[i];
    const cChildren = comp.$refs.children;
    if (Number(comp.item.id) === Number(item.id)) {
      return comp;
    }
    if (cChildren) {
      const child = findTreeItemComponent(cChildren, item);
      if (child) {
        return child;
      }
    }
  }
  return null;
}

export function decodeHTML(htmlString) {
  const txt = document.createElement('textarea');
  txt.innerHTML = htmlString;
  return txt.value;
}

/**
 * Create a query string from an object containing key/value pairs
 * @param {Object} object - Key/value pair container
 * @return {String} query string that can be append to the end of an URL
 */
export function createQueryString(object) {
  const queries = [];

  Object.keys(object).forEach((key) => {
    let value = object[key];
    if (value instanceof Array) {
      value = value.join(',');
    }
    queries.push(`${key}=${value}`);
  });
  return queries.length > 0 ? `?${queries.join('&')}` : '';
}

/**
 * Calculate and return the start date of a period using Moment
 *
 * @param  {Moment} endDate - end date of the period
 * @param  {Object} scopePeriod - period of the considered scope : object containing  'period', 'unit' keys {
 *                             period: number of <unit>
 *                             unit: moment-understandable unit 'd', 'w', 'M'
 *                           }
 * @param  {Object} pointPeriodObj - period of one point within the scopes {
 *                             period: number of <unit>
 *                             unit: moment-understandable unit 'd', 'w', 'M'
 *                             startDay: if unit = 'w' day of week that the start date should be, if 'M' day of month
 *                           }
 *
 * @return {Moment} - start date
 */
export function calcPeriodStartDate(endDate, scopePeriod, pointPeriodObj) {
  const startDate = Moment(endDate);
  if (!scopePeriod || !pointPeriodObj) {
    startDate.subtract(1, 'd');
    return startDate;
  }
  if (pointPeriodObj.unit === 'w') {
    // Set the week day. If the week day is after the previous one, subtract an additional period
    const sDay = pointPeriodObj.startDay % 7;
    startDate.day(sDay);
    startDate.subtract(scopePeriod.period, scopePeriod.unit);
    if (sDay < endDate.day()) {
      startDate.add(1, 'w');
    }
    startDate.day(sDay);
  } else if (pointPeriodObj.unit === 'M') {
    startDate.subtract(scopePeriod.period, scopePeriod.unit);
    startDate.add(1, 'M');
    // Previous <startDay> of month
    startDate.date(pointPeriodObj.startDay);
  } else {
    startDate.subtract(scopePeriod.period, scopePeriod.unit);
    // Most of the time, the first day of an x-days period is (x - 1) days before, not (x)
    startDate.add(1, 'd');
  }
  return startDate;
}

export const AVAILABLE_PERIOD_UNITS = ['d', 'w', 'M'];
export const PERIOD_UNITS_DATA = [
  { id: 0, letter: 'd', unitTr: 'message.DAYS' },
  { id: 1, letter: 'w', unitTr: 'message.WEEKS' },
  { id: 2, letter: 'M', unitTr: 'message.MONTHS' },
];

/** Types of comment */
export const COMMENT_TYPE = {
  problem: 0,
  indicator: 1,
};

/**
 * Deep diff between two object, using lodash
 * @param  {Object} object Object compared
 * @param  {Object} base   Object to compare with
 * @return {Object}        Return a new object who represent the diff
 */
export function debugDeepDiff(object, base) {
  function changes(o, b) {
    return transform(o, (result, value, key) => {
      if (!isEqual(value, b[key])) {
        result[key] = (isObject(value) && isObject(b[key])) ? changes(value, b[key]) : value;
      }
    });
  }
  return changes(object, base);
}
window.debugDeepDiff = debugDeepDiff;

/**
 * Calculate the widht of a string using canvas.measureText
 * Source: https://stackoverflow.com/questions/118241/calculate-text-width-with-javascript
 *
 * WARNING: 'em' unit isn't supported unless the canvas is appended to the DOM body
 *
 * @param  {string} text - The text to be rendered
 * @param  {String} font - The css font descriptor that text is to be rendered with
 *                         (e.g. "bold 14px verdana").
 * @return {Number} - Width in pixels
 */
export function getTextWidth(text, font) {
  // re-use canvas object for better performance
  const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement('canvas'));
  const context = canvas.getContext('2d');
  context.font = font;
  const metrics = context.measureText(text);
  return metrics.width;
}

export const defaultFont = 'Work Sans';

/**
 * Check any error occuring during user edition/creation
 * @param  {Object} xhrResponse     - XHR response
 * @param  {Boolean} [doToast=true] - If set to false, don't display a toast message
 */
export function handleUserEditionError(xhrResponse, doToast = true) {
  const { userObject } = xhrResponse.data;
  const userNames = i18n.t('fullNameFormat', userObject);
  const quote = i18n.t('message.QUOTE');

  let msg = '';
  let details = '';
  if (xhrResponse.data.code === -2) {
    msg = i18n.t('message.CONFIG_USERNAME_ALREADY_EXISTS');
    details = `${i18n.t('message.TWO_DOTS')}${quote}${userObject.username}${quote}`;
  } else if (xhrResponse.data.code === -3) {
    msg = i18n.t('message.CONFIG_EMAIL_ALREADY_IN_USE');
    details = `${i18n.t('message.TWO_DOTS')}${quote}${userObject.email}${quote}`;
  } else if (xhrResponse.data.code === -4) {
    msg = i18n.t('message.CONFIG_EMAIL_INVALID');
    details = `${i18n.t('message.TWO_DOTS')}${quote}${userObject.email}${quote}`;
  } else if (xhrResponse.data.code === -5) {
    msg = i18n.t('message.CONFIG_USER_MUST_HAVE_TEAM');
  } else if (xhrResponse.data.code === -6) {
    msg = i18n.t('message.CONFIG_SSO_ID_ALREADY_IN_USE');
    details = `${i18n.t('message.TWO_DOTS')}${quote}${userObject.ssoId}${quote}`;
  }
  const fullMessage = `\
    ${msg}\
    ${details}\
    ${i18n.t('message.CONTENT_BETWEEN_PARENTHESES', { content: userNames })}`;
  if (doToast) {
    toastr.error(fullMessage);
  }
  return fullMessage;
}

/**
 * Try to use JSON.parse on a string. Otherwise returns the string itself
 * @param  {String} str     String to parse
 * @return {Object|String}  If the object was successfully parsed, retunr it, otherwise return the string
 */
export function parseStringToObject(str) {
  try {
    const parsed = JSON.parse(str);
    return parsed instanceof Object ? parsed : String(parsed);
  } catch (e) {
    return String(str);
  }
}

/**
 * Equivalent of media queries for the size of list items, such as problem items and info items.
 * @type {Array}
 */
export const itemWidthClasses = [
  { width: 330, className: 'sm-small-portrait-size' },
  { width: 509, className: 'sm-portrait-size' },
  { width: 869, className: 'sm-landscape-size' },
  { width: 1155, className: 'tablet-size' },
];

export default {
  shizenLogo,
  keepIAOnRouteChange,
  isMobile,
  isSmartphone,
  isTouchDevice,
  capitalizeFirstLetter,
  nestedFindItemWithId,
  preventPastingStyles,
  delayResize,
  autoResize,
  removableWord,
  removeHTMLSpans,
  calert,
  secondsToArray,
  getLastWorkingDay,
  stringToCharCodes,
  sliderProperties,
  noTooltipSliderProperties,
  treeAsArray,
  parseKeywords,
  setCursorAtEnd,
  reduceMultipleImages,
  treeTraversal,
  treeIdsText,
  decodeHTML,
  parseWorkingDays,
  isWorkingDay,
  getWorkingDaysStartDate,
  getRandomInt,
  detectEscapeKey,
  undetectEscapeKey,
  nestedFlatten,
  safeString,
  safeAutocompleteString,
  calcPeriodStartDate,
  textareaAutoSize,
  getRandomColor,
  getRandomRGB,
  getTextWidth,
  handleUserEditionError,
  parseStringToObject,
  removeTrailingBreak,
  AVAILABLE_PERIOD_UNITS,
  PERIOD_UNITS_DATA,
  itemWidthClasses,
};

// IE missing functions
if (!Element.prototype.remove) {
  /* eslint-disable-next-line */
  Element.prototype.remove = function () {
    if (this.parentNode) {
      this.parentNode.removeChild(this);
    }
  };
}

// Count number of decimal numbers
/* eslint-disable-next-line */
Number.prototype.countDecimals = function () {
  if (Math.floor(this.valueOf()) === this.valueOf()) return 0;
  return this.toString().split('.')[1].length || 0;
};

/** Same as toFixed but adaptable */
/* eslint-disable-next-line */
Number.prototype.sToFixed = function (number) {
  if (number >= 0 && number < 10 && Number.isInteger(number)) {
    const raise = 10 ** number;
    const res = Math.round(this * (raise)) / raise;
    return String(isNaN(res) ? 0 : res);
  }
  return String(isNaN(this) ? 0 : this);
};

/** Set the value of a number to a specified boundary if it overruns it */
/* eslint-disable-next-line */
Number.prototype.sBetweenBoundaries = function (min, max) {
  if (isNaN(this) || this < min) {
    return min;
  }
  if (this > max) {
    return max;
  }
  return this;
};

/** Remove all accents from a string */
/* eslint-disable-next-line */
Object.defineProperty(String.prototype, 'sAccentless', {
  get() {
    return this.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  },
});

/**
 * Call find on elements of the array
 * @param  {string} key - key of array elements. `.find` will be called on each arrayItem[key]
 * @param  {function} findFunction - callback to run as the argument of .find()
 */
/* eslint-disable-next-line */
Object.defineProperty(Array.prototype, 'nestedFind', {
  enumerable: false,
  value(key, findFunction) {
    this.find(parentItem => parentItem[key].find(findFunction));
  },
});


/**
 * Use to check if most elements of the array comply to the callback
 * @param  {[type]}  fun     [description]
 * @param  {Boolean} thisArg [description]
 * @return {[type]}          [description]
 */
/* eslint-disable-next-line */
Object.defineProperty(Array.prototype, 'most', {
  enumerable: false,
  value(fun, thisArg) {
    if (this !== null && typeof fun === 'function') {
      let countTrue = 0;
      const len = this.length;
      const halfLen = len / 2;
      for (let i = 0; i < len; i++) {
        if (fun.call(thisArg, this[i], i, this)) {
          countTrue++;
        }
        if (countTrue > halfLen) {
          return true;
        }
      }
      return countTrue > halfLen;
    }
    return false;
  },
});


/**
 * Strip the object of some of its properties
 * @param  {Array} propertyKey - array of strings which are properties of this
 * @return {Object} - this after the change
 */
/* eslint-disable-next-line */
Object.defineProperty(Object.prototype, 'shizenStrip', {
  value(propertyKeys) {
    for (let i = 0, len = propertyKeys.length; i < len; i++) {
      if (typeof propertyKeys[i] === 'string') {
        delete this[propertyKeys[i]];
      }
    }
    return this;
  },
  enumerable: false,
});

/**
 * Stringify a range object of moment instances
 * @return {Object}  Self with range stringified
 */
/* eslint-disable-next-line */
Object.defineProperty(Object.prototype, 'sStrRange', {
  get() {
    if (this.start && this.end && Moment.isMoment(this.start) && Moment.isMoment(this.end)) {
      return {
        ...this,
        start: this.start.format('YYYY-MM-DD HH:mm:ss'),
        end: this.end.format('YYYY-MM-DD HH:mm:ss'),
      };
    }
    return this;
  },
});

// This polyfill is necessary for Chrome < 62 when using tiptap editor
// https://gitlab.com/moongoal/js-polyfill-object.fromentries/-/blob/master/index.js
if (!Object.fromEntries) {
  /* eslint-disable-next-line */
  Object.defineProperty(Object, 'fromEntries', {
    value(entries) {
      if (!entries || !entries[Symbol.iterator]) {
        throw new Error('Object.fromEntries() requires a single iterable argument');
      }

      const o = {};
      Object.keys(entries).forEach((key) => {
        const [k, v] = entries[key];
        o[k] = v;
      });
      return o;
    },
  });
}

// This polyfill is necessary for Chrome < 67 when using tiptap editor
if (!Array.prototype.flat) {
  /* eslint-disable-next-line */
  Object.defineProperty(Array.prototype, 'flat', {
    value(depth = 1) {
      return this.reduce((flat, toFlatten) => flat.concat((Array.isArray(toFlatten) && (depth > 1))
        ? toFlatten.flat(depth - 1)
        : toFlatten), []);
    },
  });
}
